<template>
    <div>
        <card-header icon="fa-envelopes-bulk">
            <template #title>
                View Communication
            </template>
        </card-header>

        <card-body >
            <card-list>
                <data-row mini title="To">{{comm.to}}</data-row>
                <data-row mini title="From">{{comm.from}}</data-row>
                <data-row mini title="Subject">{{comm.subject}}</data-row>
                <data-row mini title="Created">{{comm.created_at | moment('MMMM Do YYYY, h:mm:ss a')}}</data-row>
                <data-row mini title="ID">{{comm.message_id}}</data-row>

                <container-list-item padded>
                    <div v-html="comm.raw_html"></div>
                </container-list-item>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import NavigationListItem from "@/TIER/components/NavigationListItem";
    import CardContainer from "@/TIER/components/CardContainer";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";

    import {client as http} from '@/http_client';
    import async from "async";
    import DataRow from "../../TIER/components/DataRow";
    import UserTile from "../../components/tiles/UserTile";
    import TransactionTile from "../../components/tiles/TransactionTile";
    import PlanCommunicationTile from "../../components/tiles/PlanCommunicationTile.vue";
    import ContainerListItem from "../../TIER/components/ContainerListItem.vue";

    export default {
        components: {ContainerListItem, PlanCommunicationTile, TransactionTile, UserTile, DataRow, SeparatorListItem, CardFooter, CardToolbar, CardContainer, NavigationListItem, CardList, CardBody, CardHeader},
        props: ['card', 'props', 'child'],
        data() {
            return {
                comms: [],
                comm: null
            };
        },
        methods: {
            loadPlan: function() {
                this.$emit('loading', true);
                async.series([
                    (cb) => {
                        // todo: this is not efficient, we should be able to get the communication directly
                        http.get('payment-plans/' + this.props.planId, {force: true}).then(response => {
                            this.comms = response.data.communications;
                            this.comm = this.comms.find(comm => comm.id === parseInt(this.props.commId));
                            cb();
                        }).catch(err => {
                            cb(err);
                        });
                    }
                ], err => {
                    this.$emit('loading', false);
                });
            }
        },
        mounted() {
            this.loadPlan();
        }
    };
</script>

<style>
    .fa-check {
        color: green;
    }

    .fa-ban {
        color: red;
    }
</style>
